export default __webpack_public_path__ + "static/kioskBoothRightLeft-ea32782a83331798b33b2c7eae56cee9.png";